import React, { useEffect, useState } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { FormControl, FormHelperText, FormLabel, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateConsent } from "../../redux/user/userSlice";
import { useTranslation } from "react-i18next";
export default function Consent(props) {
	const [error, setError] = useState(false);
	const consent = useSelector((state) => state.user.consent);
	const dispatch = useDispatch();
	const { verifier, renderControls, handleNext, handleBack, prefilled } = props;
	const { t } = useTranslation();
	useEffect(() => {
		console.log("prefilled: ", prefilled);
	}, [prefilled]);
	const handleNextConsent = () => {
		console.log(consent);
		if (verifier(consent)) {
			setError(false);
			handleNext();
		} else {
			setError(true);
		}
	};
	const handleConsentCheckbox = (e) => {
		dispatch(updateConsent({ [e.target.name]: e.target.checked }));
	};
	return (
		<React.Fragment>
			<FormControl error={error}>
				<Typography>&nbsp;</Typography>
				<Typography>{t("Consent Line 1")}</Typography>
				<Typography>&nbsp;</Typography>
				<Typography>{t("Consent Line 2")}</Typography>
				<Typography>&nbsp;</Typography>

				<FormGroup>
					<FormControlLabel control={<Checkbox name="privacy" onChange={handleConsentCheckbox} checked={consent.privacy} />} label={t("Consent Selection 1")} />
					<FormControlLabel control={<Checkbox name="age" onChange={handleConsentCheckbox} checked={consent.age} />} label={t("Consent Selection 2")} />
					<FormControlLabel
						control={<Checkbox name="vulnerability" onChange={handleConsentCheckbox} checked={consent.vulnerability} />}
						label={t("Consent Selection 3")}
					/>
				</FormGroup>
				{error && <FormHelperText style={{ fontSize: "1rem" }}>You must check all boxes if you want to proceed</FormHelperText>}
			</FormControl>
			{renderControls(handleNextConsent, handleBack, false, prefilled)}
		</React.Fragment>
	);
}
